import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_BANNER_REQUEST } from "./constants";
import { Action, Banner } from "./types";

function items(state: Banner[] = [], action: Action): Banner[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_BANNER_REQUEST):
      return action.payload.data || [];
    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_BANNER_REQUEST:
      return true;
    case getSuccessActionType(FETCH_BANNER_REQUEST):
    case getFailureActionType(FETCH_BANNER_REQUEST):
      return false;

    default:
      return state;
  }
}

export const bannersList = combineReducers({ items, isFetching });
